var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { memo, useEffect, useMemo, useState } from 'react';
import classnames from 'classnames/bind';
import { PREVIEWS, PREVIEW_VARIANS } from './_constants';
import { HomePagePreview } from './_components/home-page-preview';
import styles from './index.module.scss';
export { PREVIEW_VARIANS } from './_constants';
var cn = classnames.bind(styles);
var BLOCK_NAME = 'Preview';
export var Preview = memo(function (_a) {
    var _b;
    var mobileOnly = _a.mobileOnly, _c = _a.variant, variant = _c === void 0 ? PREVIEW_VARIANS['home-page'] : _c, _d = _a.timeout, timeout = _d === void 0 ? 500 : _d, _e = _a.immediatelyShown, immediatelyShown = _e === void 0 ? false : _e;
    var _f = __read(useState(immediatelyShown), 2), shown = _f[0], setIsShown = _f[1];
    var PreviewComponent = useMemo(function () { var _a; return (_a = PREVIEWS[variant]) !== null && _a !== void 0 ? _a : HomePagePreview; }, [variant]);
    useEffect(function () {
        if (immediatelyShown) {
            return;
        }
        var timer = setTimeout(function () {
            setIsShown(true);
        }, timeout);
        return function () {
            clearTimeout(timer);
        };
    }, [immediatelyShown, timeout]);
    return (React.createElement("div", { className: cn(BLOCK_NAME, (_b = {},
            _b["".concat(BLOCK_NAME, "--mobile-only")] = mobileOnly,
            _b)) }, shown && React.createElement(PreviewComponent, null)));
});
